import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/mergeMap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private title:Title,private router:Router){}
  ngOnInit() {

    

    this.router.events
    .filter(event => event instanceof RoutesRecognized)
    .map((event: RoutesRecognized) => {
        return event.state.root.firstChild.data['title'];
    })
    .subscribe(customData => {
       this.title.setTitle(customData);
    });
    
    
    
  }
  
}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/app.component.ts